export function getCartSuggestedProducts(products = [], cart = [], limit = 7) {

  

    if (!Array.isArray(products)) products = [];
    if (!Array.isArray(cart)) cart = [];
    // console.log(cart)
  
    //  If CART IS EMPTY → return ONLY 1 product per type
    if (cart.length == 0) {
  
      // 1. Get unique types from products automatically
      const uniqueTypes = [...new Set(
        products
          .filter(p => p?.productType)
          .map(p => p.productType)
      )];
      // console.log("uniqueTypes",uniqueTypes)
    
      const selected = [];
      const usedTypes = new Set();
    
      for (let type of uniqueTypes) {
    
        const product = products.find(p =>
          p?.productType === type &&
          !p?.outOfStock

        );
    
        if (product && !usedTypes.has(type)) {
          selected.push(product);
          usedTypes.add(type);
        }
    
        if (selected.length === limit) break;
      }
    
      return selected;
    }
  
  
    // 1. Get all skuRelationIds present in cart
    const cartSkuIds = new Set(
      cart
        .filter(item => item?.product?.skuRelationId)
        .map(item => item.product?.skuRelationId)
    );
  
    // 2. Track already added skuRelationIds (to avoid duplicate)
    const usedSkuIds = new Set();
  
    const suggestions = [];
  
    for (let product of products) {
  
      //  Make sure product exists
      if (!product || !product.skuRelationId) continue;
  
      // Skip if already in cart
      if (cartSkuIds.has(product.skuRelationId)) continue;
  
      // Skip if duplicate skuRelationId already added
      if (usedSkuIds.has(product.skuRelationId)) continue;
  
      suggestions.push(product);
      usedSkuIds.add(product.skuRelationId);
  
      if (suggestions.length === limit) break;
    }
  
    return suggestions;
  }
  